<template>
    <div class="eis-content">
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
import store from '../store.js';

export default {
    data () {
        return {}
    },
    async beforeRouteEnter (to, from, next) {
        let permitted = to.matched.filter(
            record => to.name == record.name && store.getters.hasPerm(
                record.meta.requiresPerm
            )
        );
        if(permitted.length == 0){
        	next({ path: "/users" });
        }else{
             next();
        }
    }
};
</script>
<style type="text/css">
.eis-content{
    height: 80.5%;
}

@media only screen and (max-width: 1190px) {
  /* For mobile phones: */
}

@media only screen and (min-width: 468px) and (max-width: 780px) {
  /* For mobile phones: */
  .eis-content{ height: auto }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  .eis-content{ height: auto }
}
</style>>



// WEBPACK FOOTER //
// src/components/DashboardContent.vue